import { useState, useCallback, forwardRef, useImperativeHandle } from "react";
import throttle from 'lodash/throttle';


const BgImage = forwardRef((props, ref) => {
    
    const [positionBg, setPositionBg] = useState({x: -20, y: 0});
      
    const [bgImgId, setBgImgId] = useState('home-image');

    const bgStyle = {
        transform: `translate(${positionBg.y}px, ${positionBg.x}px)`,
    }

    
   useImperativeHandle(ref, () => ({
		handleMouseMove2: (event) => {
            // console.log(event.type);
			handleMouseMove(event);
		}
	}));

    const handleMouseMove = useCallback(throttle((event) => {
        let setx = Math.round(-20 + (event.clientX /60));
        let sety = Math.round(0 - (event.clientY / 60));
        // requestAnimationFrame(()=>{
            setPositionBg({x: setx, y: sety});
        // })      
    }, 30), []);
    

    return (
        <div className='main-image' id={bgImgId} style={bgStyle}/>
    );
});

export default BgImage;